import React, {useCallback, useEffect, useState} from 'react';
import axios from 'axios';

export default function PaymentDepartmentMapping({api, refreshKey}) {
  const [data, setData] = useState({departments: [], abteilungen: []});
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(null);

  const load = useCallback(async () => {
    const response = await axios.get(`${api}/developer/payment-mappings`);
    setData(response.data);
  }, [api]);
  useEffect(() => {
    load().catch(() => setError('Payment-Zuordnungen konnten nicht geladen werden.'));
    // Reload after a Payment synchronization updates the cached choices.
  }, [load, refreshKey]);

  const save = async (departmentId, paymentId) => {
    setSaving(departmentId);
    setError('');
    try {
      await axios.put(`${api}/developer/departments/${departmentId}/payment-mapping`, {
        payment_abteilung_id: paymentId || null,
      });
      await load();
    } catch (err) {
      setError(err.response?.data?.detail || 'Die Zuordnung konnte nicht gespeichert werden.');
    } finally {
      setSaving(null);
    }
  };

  return (
    <section className="space-y-3" aria-label="Payment-Zuordnung">
      <h3 className="text-lg font-semibold">Payment-Zuordnung</h3>
      <p className="text-sm text-gray-600">Verknüpfen Sie jede lokale Abteilung mit ihrer Payment-Abteilung. Die Zuordnung bleibt bei Umbenennungen erhalten.</p>
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      {data.departments.map(department => (
        <div key={department.department_id} className="space-y-1">
          <label htmlFor={`payment-mapping-${department.department_id}`} className="block text-sm font-medium">{department.department_name}</label>
          <select
            id={`payment-mapping-${department.department_id}`}
            className="w-full border border-gray-300 rounded-lg p-2"
            value={department.payment_abteilung_id || ''}
            disabled={saving !== null}
            onChange={event => save(department.department_id, event.target.value)}
          >
            <option value="">Nicht zugeordnet</option>
            {department.payment_abteilung_id && !department.mapping_found && (
              <option value={department.payment_abteilung_id}>Gespeicherte Zuordnung nicht im Cache: {department.payment_abteilung_id}</option>
            )}
            {data.abteilungen.map(item => (
              <option key={item.abteilung_id} value={item.abteilung_id} disabled={data.departments.some(other => other.department_id !== department.department_id && other.payment_abteilung_id === item.abteilung_id)}>
                {item.abteilung_name} ({item.abteilung_id})
              </option>
            ))}
          </select>
          {!department.mapping_found && <p className="text-sm text-amber-700">Keine gültige Zuordnung. Payment synchronisieren oder eine Abteilung auswählen.</p>}
        </div>
      ))}
    </section>
  );
}
